module.exports = __webpack_public_path__ + "img/237.657b35b3.jpg";